var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import produce from "immer";
export class Store {
    constructor(initialState, config) {
        this.watcher = new Set();
        this.selectorCache = new Map();
        this._cachedValue = null;
        this._state = initialState;
        this.config = {
            cacheHandler: (config === null || config === void 0 ? void 0 : config.cacheHandler) || null,
            cacheKey: (config === null || config === void 0 ? void 0 : config.cacheKey) || null,
            cacheAllowlist: (config === null || config === void 0 ? void 0 : config.cacheAllowlist) || null,
            cacheBlocklist: (config === null || config === void 0 ? void 0 : config.cacheBlocklist) || null,
        };
        this.readCache();
    }
    getState() {
        return this._state;
    }
    select(selector) {
        return selector(this._state);
    }
    setState(state) {
        this._state = state;
        this.watcher.forEach((callback) => {
            try {
                callback(this._state);
            }
            catch (error) {
                console.error("Error in Store subscription callback:", error);
            }
        });
        this.writeCache();
    }
    update(callbackOrState) {
        if (typeof callbackOrState === "function") {
            this.setState(produce(this._state, callbackOrState));
        }
        else {
            this.setState(callbackOrState);
        }
    }
    assignToState(state) {
        this.setState(Object.assign({}, this._state, state));
    }
    subscribe(callback) {
        this.watcher.add(callback);
        return () => {
            this.watcher.delete(callback);
        };
    }
    subscribeSelection(selector, callback) {
        const selectorCallback = () => {
            const cache = this.selectorCache.get(selector);
            const selection = selector(this._state);
            if (!cache || cache !== selection) {
                this.selectorCache.set(selector, selection);
                callback(selection);
            }
        };
        this.watcher.add(selectorCallback);
        return () => {
            this.watcher.delete(selectorCallback);
            this.selectorCache.delete(selector);
        };
    }
    readCache() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config.cacheHandler && this.config.cacheKey) {
                try {
                    const handler = this.config.cacheHandler;
                    const key = `store:cache:${this.config.cacheKey}`;
                    // TODO:
                    // There is a race condition when services with a cached state are created
                    // If the service uses the DeviceStorage service as a cache handler, the adapter
                    // is not ready before the state reads the cache
                    // This workaround will disable cache handlers and use local storage instead
                    // let cache = await handler.get(key);
                    let cache = JSON.parse(window.localStorage.getItem(key) || "{}");
                    cache = this.handleCacheLists(cache);
                    this.assignToState(cache);
                }
                catch (error) {
                    console.error(`@opendash/store: Error while loading cache:`, error);
                }
            }
        });
    }
    writeCache() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config.cacheHandler && this.config.cacheKey) {
                try {
                    const handler = this.config.cacheHandler;
                    const key = `store:cache:${this.config.cacheKey}`;
                    const cache = this.handleCacheLists(this._state);
                    const cacheHash = JSON.stringify(cache);
                    if (this._cachedValue !== cacheHash) {
                        // TODO:
                        // await handler.set(key, cache);
                        window.localStorage.setItem(key, JSON.stringify(cache));
                        this._cachedValue = cacheHash;
                        console.log(`@opendash/store: Cached '${key}':`, cache);
                    }
                }
                catch (error) {
                    console.error(`@opendash/store: Error while writing cache:`, error);
                }
            }
        });
    }
    handleCacheLists(state) {
        const result = Object.assign({}, state);
        if (Array.isArray(this.config.cacheAllowlist) &&
            this.config.cacheAllowlist.length > 0) {
            for (const key of Object.keys(result)) {
                if (!this.config.cacheAllowlist.includes(key)) {
                    delete result[key];
                }
            }
        }
        if (Array.isArray(this.config.cacheBlocklist) &&
            this.config.cacheBlocklist.length > 0) {
            for (const key of Object.keys(result)) {
                if (this.config.cacheBlocklist.includes(key)) {
                    delete result[key];
                }
            }
        }
        return result;
    }
}
//# sourceMappingURL=Store.js.map